/* ============================================================================
   ss-tabs-video.js — tab "How to apply / How to REMOVE"
   - ARIA tablist/tab/tabpanel, kích hoạt THỦ CÔNG (manual activation):
     mũi tên chỉ di chuyển focus, Enter/Space/click mới mở tab.
     Theo WAI-ARIA APG: dùng manual activation khi mở panel tốn băng thông.
   - Lazy: chỉ gắn src cho video của tab ĐANG MỞ. Video tab ẩn không tải.
   - Video tab đầu chỉ tải khi section lọt vào viewport.
   - Tôn trọng prefers-reduced-motion (không autoplay).
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadVideo(panel, autoplay) {
    var video = panel.querySelector('[data-ss-video]');
    if (!video) return;
    var src = video.getAttribute('data-ss-src');
    if (src && !video.getAttribute('src')) {
      video.setAttribute('preload', 'metadata');
      video.setAttribute('src', src);
      video.load();
    }
    if (autoplay && !REDUCED) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function stopVideo(panel) {
    var video = panel.querySelector('[data-ss-video]');
    if (video && !video.paused) video.pause();
  }

  function init(root) {
    if (!root || root.dataset.ssTabsReady === '1') return;
    root.dataset.ssTabsReady = '1';

    var list = root.querySelector('[data-ss-tabs-list]');
    if (!list) return;

    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    // getElementById để khỏi phải escape id do Shopify sinh (có dấu __ và --)
    var panels = tabs.map(function (tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    });

    var autoplayOn = root.getAttribute('data-ss-autoplay') !== 'false';
    var current = 0;

    tabs.forEach(function (tab, i) {
      if (tab.getAttribute('aria-selected') === 'true') current = i;
    });

    function select(index, moveFocus) {
      if (index === current) {
        if (moveFocus) tabs[index].focus();
        return;
      }
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-active', on);
        var panel = panels[i];
        if (!panel) return;
        if (on) {
          panel.hidden = false;
          panel.classList.add('is-entering');
          window.setTimeout(function () { panel.classList.remove('is-entering'); }, 400);
          loadVideo(panel, autoplayOn);
        } else {
          stopVideo(panel);
          panel.hidden = true;
        }
      });
      current = index;
      if (moveFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        var next = null;

        if (key === 'ArrowRight' || key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (key === 'ArrowLeft' || key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (key === 'Home') next = 0;
        else if (key === 'End') next = tabs.length - 1;
        else if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          select(i, false);
          return;
        }

        if (next === null) return;
        event.preventDefault();
        // Manual activation: chỉ dời focus, chưa mở tab (chưa tải video).
        tabs.forEach(function (t, j) { t.setAttribute('tabindex', j === next ? '0' : '-1'); });
        tabs[next].focus();
      });
    });

    // Video của tab đang mở: chỉ tải khi section lọt vào viewport.
    var first = panels[current];
    if (first) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            loadVideo(first, autoplayOn);
          });
        }, { rootMargin: '200px 0px' });
        io.observe(root);
      } else {
        loadVideo(first, autoplayOn);
      }
    }

    // Tab bị ẩn khỏi màn hình thì dừng video cho đỡ tốn pin.
    if ('IntersectionObserver' in window) {
      var pauseIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var panel = panels[current];
          if (panel) stopVideo(panel);
        });
      }, { threshold: 0 });
      pauseIO.observe(root);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ss-tabs]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor render lại section
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = (event.target || document).querySelectorAll('[data-ss-tabs]');
    Array.prototype.forEach.call(nodes, function (root) { root.dataset.ssTabsReady = ''; });
  });
})();
